import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { IndividualDiscountCard } from "./DiscountCards/IndividualDiscountCard";
import { StepArenaIndividualSection } from "./DiscountCards/StepArenaIndividualSection";
import { SchoolDiscountCard } from "./DiscountCards/SchoolDiscountCard";
import { FitnessKidDiscountCard } from "./DiscountCards/FitnessKidDiscountCard";
import { AdultsFitnessDiscountCard } from "./DiscountCards/AdultsFitnessDiscountCard";
import { TeamDiscountCard } from "./DiscountCards/TeamDiscountCard";
import { SummerSchoolSection } from "./SummerSchoolSection";
import { DailyPassSection } from "./DailyPassSection";
import { useReception } from "../../ReceptionContext";

import Plus from '../../assets/images/Plus.png';
import Cross from '../../assets/images/crossIcon.png';

// ============================================
// BLACK FRIDAY PRICES (CURRENT - ACTIVE)
// ============================================
const discountData = {
    Individual: {
        type: "individual",
        premium: {
            months: [
                { time: 1, cost: 60 },
                { time: 3, cost: 145 },
                { time: 6, cost: 240 },
                { time: 12, cost: 360 },
            ],
            entries: 'unlimited',
            discount: 0,
        },
        basic: {
            months: [
                {
                    time: 1,
                    options: [
                        { entries: 8, cost: 35 },
                   
                    ]
                },
                {
                    time: 3,
                    options: [
                        { entries: 24, cost: 85 },
                    ]
                },
                    {
                    time: 12,
                    options: [
                        { entries: 96, cost: 360 },
                    ]
                }
            ],
            entries: 'variable',
            discount: 0,
        },
    },
    School: {
        type: "School",
        Child: { months: 2, cost: 91, entries: 16 },
        PlusFiveYears: { months: 2, cost: 105, entries: 24 },
    },
    Team: {
        type: "Team",
        Children: {
            oneMonth: [
                { entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 45, discount: 0 },
                { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 55, discount: 0 },
                { entries: "4 Hyrje në Javë - 16 Hyrje në Muaj", cost: 70, discount: 0 },
                { entries: "5 Hyrje në Javë - 20 Hyrje në Muaj", cost: 90, discount: 0 },
            ],
            threeMonths: [
                { entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 115, discount: 0 },
                { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 135, discount: 0 },
                { entries: "4 Hyrje në Javë - 16 Hyrje në Muaj", cost: 155, discount: 0 },
                { entries: "5 Hyrje në Javë - 20 Hyrje në Muaj", cost: 200, discount: 0 },
            ],
                
        },
        Infants: {
            oneMonth: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 50, discount: 0 }],
            threeMonths: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 120, discount: 0 }],
        },
        Adults: {
            oneMonth: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 50, discount: 0 }],
            threeMonths: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 120, discount: 0 }],
        },
    },
    GroupReservations: {
        type: "GroupReservations",
        options: [
            { label: "Shfrytezimi i pishinës (2.5€/person)", cost: 2.5 },
            { label: "Pishinë + trajner (4€/person)", cost: 4 },
            { label: "Pishinë + trajner + transport (5.5€/person)", cost: 5.5 }
        ]
    }
};

// ============================================
// ORIGINAL PRICES (COMMENTED - UNCOMMENT AFTER BLACK FRIDAY)
// ============================================
/*
const discountData = {
    Individual: {
        type: "individual",
        premium: {
            months: [
                { time: 1, cost: 60 },
                { time: 3, cost: 145 },
                { time: 6, cost: 240 },
                { time: 12, cost: 360 },
            ],
            entries: 'unlimited',
            discount: 0,
        },
        basic: {
            months: [
                {
                    time: 1,
                    options: [
                        { entries: 8, cost: 35 },
                    ]
                },
                {
                    time: 3,
                    options: [
                        { entries: 24, cost: 85 },
                    ]
                }
            ],
            entries: 'variable',
            discount: 0,
        },
    },
    School: {
        type: "School",
        Child: { months: 2, cost: 91, entries: 16 },
        PlusFiveYears: { months: 2, cost: 105, entries: 24 },
    },
    Team: {
        type: "Team",
        Children: {
            oneMonth: [
                { entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 45, discount: 0 },
                { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 55, discount: 0 },
                { entries: "4 Hyrje në Javë - 16 Hyrje në Muaj", cost: 70, discount: 0 },
                { entries: "5 Hyrje në Javë - 20 Hyrje në Muaj", cost: 90, discount: 0 },
            ],
            threeMonths: [
                { entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 115, discount: 0 },
                { entries: "3 Hyrje në Javë - 12 Hyrje në Muaj", cost: 135, discount: 0 },
                { entries: "4 Hyrje në Javë - 16 Hyrje në Muaj", cost: 155, discount: 0 },
                { entries: "5 Hyrje në Javë - 20 Hyrje në Muaj", cost: 200, discount: 0 },
            ],
        },
        Infants: {
            oneMonth: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 50, discount: 0 }],
            threeMonths: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 120, discount: 0 }],
        },
        Adults: {
            oneMonth: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 50, discount: 0 }],
            threeMonths: [{ entries: "2 Hyrje në Javë - 8 Hyrje në Muaj", cost: 120, discount: 0 }],
        },
    },
    GroupReservations: {
        type: "GroupReservations",
        options: [
            { label: "Shfrytezimi i pishinës (2.5€/person)", cost: 2.5 },
            { label: "Pishinë + trajner (4€/person)", cost: 4 },
            { label: "Pishinë + trajner + transport (5.5€/person)", cost: 5.5 }
        ]
    }
};
*/

export const InformationForm = ({ step, setStep, formData, setFormData, setRegistrations, registrations, form, setForm }) => {
    const { t } = useTranslation();
    const { centerId, centerName, allowedRegistrationTypes } = useReception();
    const OPT_IN_TYPES = ['Summer School', 'Daily Pass'];
    const offersType = (type) => {
        if (OPT_IN_TYPES.includes(type)) {
            return Array.isArray(allowedRegistrationTypes) && allowedRegistrationTypes.includes(type);
        }
        if (!Array.isArray(allowedRegistrationTypes) || allowedRegistrationTypes.length === 0) return true;
        return allowedRegistrationTypes.includes(type);
    };
    // Step Arena uses a different Individual plan catalog
    const isStepArena = centerName === 'Step Arena';
    const [additionalDates, setAdditionalDates] = useState([""]);
    const [dropDown, setDropDown] = useState(false);
    const [checkbox, setCheckbox] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const generateBatchId = () => {
        const timestamp = Date.now().toString(36);
        const randomNum = Math.floor(Math.random() * 1e12).toString(36);
        return `${timestamp}-${randomNum}`;
    };

    const handleRegister = async () => {
        const batchId = generateBatchId();

        if (registrations.length === 0) {
            await setFormData(prev => ({ ...prev, batchId }));
            setRegistrations(prevRegistrations => [...prevRegistrations, formData]);
        } else {
            const updatedRegistrations = registrations.map(registration => ({ ...registration, batchId }));
            setRegistrations(updatedRegistrations);
        }
    };

    const calculateTotalAmount = () => {
        const selectedOption = discountData.GroupReservations.options.find(option => option.label === formData.offer);
        return selectedOption ? selectedOption.cost * formData.numberOfPeople : 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setRegistrations(prevRegistrations => [...prevRegistrations, formData]);
        setFormData({
            firstName: '',
            parentName: '',
            lastName: '',
            dateOfBirth: '',
            address: '',
            phone: '',
            email: '',
            time: 0,
            timings: '',
            days: [],
            totalAmount: 0,
            payableAmount: 0,
            discount: 0,
            kidEntries: 0,
            swimmingExpertise: '',
            healthProblems: null,
            healthProblemDescription: '',
            type: formData?.type,
            premium: false,
            batchId: '0',
            paymentMethod: '',
            entries: '',
            ageGroup: '',
            age: 0,
            gender: ""
        });
    };

    const handleGroupReservationSubmit = async (e) => {
        e.preventDefault();
        console.log("Handling the regidtration of group",formData);

        if (!formData.institution || !formData.address || !formData.email || !formData.phone || !formData.responsiblePerson || !formData.dates || !formData.time || !formData.numberOfPeople || !formData.age || !formData.male || !formData.female || !formData.offer) {
            toast.error(t('please_fill_all_fields'));
            return;
        }

        if (!checkbox) {
            toast.error(t('agree_terms_conditions'));
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/groupreservation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...formData,
                    totalAmount: calculateTotalAmount(),
                    dateCreated: new Date(),
                    center: centerId,
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            setRegistrations(prevRegistrations => [
                ...prevRegistrations,
                result,
            ]);

            setFormData({
                institution: '',
                address: '',
                email: '',
                phone: '',
                responsiblePerson: '',
                dates: [''],
                time: '',
                numberOfPeople: '',
                age: '',
                male: 0,
                female: 0,
                offer: '',
                totalAmount: 0,
                batchId: '0',
                dateCreated: Date.now()
            });

            toast.success('Rezervimi u shtua me sukses!');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Pati një problem me dërgimin.');
        }
    };

    const handleRemoveRegistration = (index) => {
        const updatedRegistrations = registrations.filter((_, i) => i !== index);
        setRegistrations(updatedRegistrations);
    };

    const isDuplicateRegistration = () => {
        return registrations.some(registration => (
            registration.firstName === formData.firstName &&
            registration.parentName === formData.parentName &&
            registration.lastName === formData.lastName &&
            registration.dateOfBirth === formData.dateOfBirth &&
            registration.address === formData.address &&
            registration.phone === formData.phone &&
            registration.email === formData.email &&
            registration.time === formData.time &&
            registration.totalAmount === formData.totalAmount &&
            registration.payableAmount === formData.payableAmount &&
            registration.discount === formData.discount &&
            registration.kidEntries === formData.kidEntries &&
            registration.swimmingExpertise === formData.swimmingExpertise &&
            registration.healthProblems === formData.healthProblems &&
            registration.type === formData.type &&
            registration.premium === formData.premium
        ));
    };

    const isDuplicateGroupReservation = () => {
        return registrations.some(registration => (
            registration.institution === formData.institution &&
            registration.address === formData.address &&
            registration.email === formData.email &&
            registration.phone === formData.phone &&
            registration.responsiblePerson === formData.responsiblePerson &&
            registration.startDate === formData.startDate &&
            registration.endDate === formData.endDate &&
            registration.time === formData.time &&
            registration.numberOfPeople === formData.numberOfPeople &&
            registration.age === formData.age &&
            registration.gender === formData.gender &&
            registration.offer === formData.offer
        ));
    };

    const addAdditionalDate = () => {
        setAdditionalDates([...additionalDates, ""]);
    };

    const handleAdditionalDateChange = (index, value) => {
        const newDates = [...additionalDates];
        newDates[index] = value;
        setAdditionalDates(newDates);
        setFormData((prevData) => ({
            ...prevData,
            dates: newDates,
        }));
    };


    const formMapping = {
        Individual: 'individual',
        "Kids Fitness": 'kids_fitness',
        Adults: 'adults',
        "Shkolla e Notit": 'swimming_school',
        "Rezervime Grupore": 'group_reservations'
    };

    const isFitnessForm = formData?.type === 'Kids Fitness' || formData?.type === 'kids fitness' || formData?.type === 'Adults';

    // ============================================
    // BLACK FRIDAY DESIGN - COMMENT OUT AFTER BLACK FRIDAY
    // ============================================
    // Check if Black Friday design should be shown (only for Individual and Shkolla e Notit)
    const showBlackFriday = form === "Individual" || form === "Shkolla e Notit";
    // After Black Friday, change above line to: const showBlackFriday = false;

    return (
        <div className={`w-[95vw] md:w-[90vw] lg:w-[90vw] xl:w-[85vw] 2xl:w-[80vw] min-h-fit bg-white lg:container lg:mx-auto rounded-3xl px-5 md:px-10 lg:px-16 xl:px-20 pt-10 xl:pt-10 pb-10 flex flex-col font-custom2 mb-10 relative overflow-hidden ${showBlackFriday ? 'border-4 border-black-600 shadow-2xl' : ''}`}>
            {/* BLACK FRIDAY DECORATIVE ELEMENTS - COMMENT OUT AFTER BLACK FRIDAY */}
            {showBlackFriday && (
                <>
                    {/* <div className="absolute top-0 right-0 bg-black-600 text-white px-6 py-2 transform rotate-12 translate-x-4 -translate-y-2 shadow-lg z-10">
                        <span className="font-bold text-sm">BLACK FRIDAY</span>
                    </div>
                    <div className="absolute top-0 left-0 bg-black text-white px-4 py-1 transform -rotate-12 -translate-x-2 translate-y-4 shadow-lg z-10">
                        <span className="font-bold text-xs">-30% OFF</span>
                    </div> */}
                </>
            )}
            
            <div className="flex flex-col sm:flex-row w-full sm:w-[60%] justify-start gap-10">
                <div className="flex items-center gap-3">
                    <h1 className="text-4xl font-bold text-gray-700">{t('register')}</h1>
                    {/* BLACK FRIDAY SALE BADGE - COMMENT OUT AFTER BLACK FRIDAY */}
                    {/* {showBlackFriday && (
                        <span className="bg-gradient-to-r from-black-600 to-black-800 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
                            SALE
                        </span>
                    )} */}
                </div>
                <div className="relative flex flex-col gap-2 rounded-2xl">
                    {/* BLACK FRIDAY DROPDOWN STYLING - COMMENT OUT AFTER BLACK FRIDAY */}
                    <button onClick={() => setDropDown(!dropDown)} id="dropdownDefaultButton" data-dropdown-toggle="dropdown" className={`${showBlackFriday ? 'bg-gradient-to-r from-black-50 to-black-100 border-2 border-black-300 text-black-700 font-bold shadow-md hover:shadow-lg' : 'bg-gray-100 text-black font-medium'} rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center transition-all`} type="button">{t(form)} <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                        </svg>
                    </button>
                    <div id="dropdown" className={`z-10 bg-white text-black -right-1 top-12 absolute divide-y divide-gray-100 rounded-lg shadow w-44 ${dropDown ? 'block' : 'hidden'}`}>
                        <ul className="py-2 text-sm" aria-labelledby="dropdownDefaultButton">
                            {offersType('Individual') && (
                            <li onClick={() => { setForm("Individual"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Individual", })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Individual" ? (showBlackFriday ? 'bg-black-100 text-black-700 font-bold border-l-4 border-black-600' : 'bg-gray-200') : (showBlackFriday ? 'hover:bg-transparent-50 hover:text-black-600 hover:border-l-4 hover:border-black-400' : 'hover:bg-gray-200')} transition-all`}>
                                    {t('Individual')}
                                </a>
                            </li>
                            )}
                            {offersType('Shkolla e Notit') && (
                            <li onClick={() => { setForm("Shkolla e Notit"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Shkolla e Notit", })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Shkolla e Notit" ? (showBlackFriday ? 'bg-black-100 text-black-700 font-bold border-l-4 border-black-600' : 'bg-gray-200') : (showBlackFriday ? 'hover:bg-transparent-50 hover:text-black-600 hover:border-l-4 hover:border-black-400' : 'hover:bg-gray-200')} transition-all`}>
                                    {t('Shkolla e Notit')}
                                </a>
                            </li>
                            )}
                            {offersType('Kids Fitness') && (
                            <li onClick={() => { setForm("Kids Fitness"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Kids Fitness", })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Kids Fitness" ? 'bg-gray-200' : 'hover:bg-gray-200'}`}>
                                    {t('Kids Fitness')}
                                </a>
                            </li>
                            )}
                            {offersType('Adults') && (
                            <li onClick={() => { setForm("Adults"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Adults", })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Adults" ? 'bg-gray-200' : 'hover:bg-gray-200'}`}>
                                    Step Adults
                                </a>
                            </li>
                            )}
                            {offersType('Rezervime Grupore') && (
                            <li onClick={() => { setForm("Rezervime Grupore"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Rezervime Grupore", })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Rezervime Grupore" ? 'bg-gray-200' : 'hover:bg-gray-200'}`}>
                                    {t('Rezervime Grupore')}
                                </a>
                            </li>
                            )}
                            {offersType('Summer School') && (
                            <li onClick={() => { setForm("Summer School"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Summer School", program: "summer", days: [], tempDays: [] })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Summer School" ? 'bg-gray-200' : 'hover:bg-gray-200'}`}>
                                    Summer School
                                </a>
                            </li>
                            )}
                            {offersType('Daily Pass') && (
                            <li onClick={() => { setForm("Daily Pass"); setDropDown(!dropDown); setFormData((prevData) => ({ ...prevData, type: "Daily Pass", entryDate: new Date().toISOString().split('T')[0] })); }}>
                                <a href="#" className={`block px-4 py-2 ${form === "Daily Pass" ? 'bg-gray-200' : 'hover:bg-gray-200'}`}>
                                    Hyrja Ditore
                                </a>
                            </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="flex flex-col w-full gap-10 mt-10 sm:flex-row">
                {/* Mobile: Show packages first, Desktop: Show form first */}
                <div className="flex flex-col w-full sm:w-[55%] text-gray-600 gap-5 min-h-full order-2 sm:order-1">
                    <div className="flex items-center gap-3">
                        <h2 className="ml-0 text-xl font-bold sm:ml-2 xl:ml-5">Të dhënat tuaja</h2>
                     
                        {/* {showBlackFriday && (
                            <span className="bg-black-100 text-black-700 px-2 py-1 rounded text-xs font-semibold border border-black-300">
                                BLACK FRIDAY
                            </span>
                        )} */}
                    </div>
                    <div className="flex flex-col h-full gap-6 pl-5 pr-8 lg:pr-10 xl:pr-14 2xl:pr-20 sm:border-r-[1px] sm:border-gray-300">
                        {/* New Form Fields for Group Reservations */}
                        {form === "Rezervime Grupore" && (
                            <>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Institucioni</label>
                                    <input type="text" value={formData.institution} onChange={(e) => handleInputChange(e)} name="institution" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Adresa</label>
                                    <input type="text" value={formData.address} onChange={(e) => handleInputChange(e)} name="address" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Email</label>
                                    <input type="email" value={formData.email} onChange={(e) => handleInputChange(e)} name="email" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Telefon</label>
                                    <input type="text" value={formData.phone} onChange={(e) => handleInputChange(e)} name="phone" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Personi Përgjegjës</label>
                                    <input type="text" value={formData.responsiblePerson} onChange={(e) => handleInputChange(e)} name="responsiblePerson" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                {additionalDates.map((date, index) => (
                                    <div key={index} className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                        <label>{index === 0 ? "Data" : `Data ${index + 1}`}</label>
                                        <input type="date" value={date} onChange={(e) => handleAdditionalDateChange(index, e.target.value)} name={`date-${index}`} className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                    </div>
                                ))}
                                <button type="button" onClick={addAdditionalDate} className="px-3 py-1 mt-2 text-gray-700 bg-gray-200 rounded-md">Add Another Date</button>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Koha</label>
                                    <input type="string" value={formData.time} onChange={(e) => handleInputChange(e)} name="time" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Numri i Personave</label>
                                    <input type="number" value={formData.numberOfPeople} onChange={(e) => handleInputChange(e)} name="numberOfPeople" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Mosha</label>
                                    <input type="number" value={formData.age} onChange={(e) => handleInputChange(e)} name="age" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Meshkuj</label>
                                    <input type="number" value={formData.male} onChange={(e) => handleInputChange(e)} name="male" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-row max-[400px]:flex-col justify-between w-full gap-0 max-[400px]:gap-2 lg:gap-5">
                                    <label>Femra</label>
                                    <input type="number" value={formData.female} onChange={(e) => handleInputChange(e)} name="female" className="border-b-[1px] border-black outline-none w-[60%] max-[400px]:w-full sm:w-[150px] xl:w-[250px] 2xl:w-[300px]" />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label>Zgjedh Ofertën</label>
                                    <select name="offer" value={formData.offer} onChange={handleInputChange} className="border-b-[1px] border-black outline-none w-full">
                                        {discountData.GroupReservations.options.map((option, index) => (
                                            <option key={index} value={option.label}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </>
                        )}

                        {form !== "Rezervime Grupore" && (
                            <>
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{t('first_name')}</label>
                                    <input type="text" value={formData.firstName} onChange={(e) => handleInputChange(e)} name="firstName" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Shkruani emrin tuaj" />
                                </div>
                                {form === "Shkolla e Notit" && (
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Emri i Prindit</label>
                                    <input 
                                    type="text" 
                                    value={formData.parentName} 
                                    onChange={(e) => handleInputChange(e)} 
                                    name="parentName" 
                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" 
                                    placeholder="Shkruani emrin e prindit"
                                    />
                                </div>
                                )}
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{t('last_name')}</label>
                                    <input type="text" value={formData.lastName} onChange={(e) => handleInputChange(e)} name="lastName" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Shkruani mbiemrin tuaj" />
                                </div>
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{t('date_of_birth')}</label>
                                    <input type="date" value={formData.dateOfBirth} onChange={(e) => handleInputChange(e)} name="dateOfBirth" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" />
                                </div>
                                <div className={`${formData?.type === 'Individual' ? 'hidden' : 'flex'} flex-col w-full gap-2`}>
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{formData?.type === "Adults" ? "Mosha" : t('child_age')}</label>
                                    <input type='number' name="age" value={formData.age} onChange={(e) => { handleInputChange(e) }} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder={formData?.type === "Adults" ? "Mosha" : "Mosha e fëmijës"} />
                                </div>
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{t('address')}</label>
                                    <input type="text" value={formData.address} onChange={(e) => handleInputChange(e)} name="address" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Shkruani adresën tuaj" />
                                </div>
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{t('phone')}</label>
                                    <input type="text" value={formData.phone} onChange={(e) => handleInputChange(e)} name="phone" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="+355 XX XXX XXXX" />
                                </div>
                                <div className="flex flex-col w-full gap-2">
                                    <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">{t('email')}</label>
                                    <input value={formData.email} type="email" onChange={(e) => handleInputChange(e)} name="email" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="example@email.com" />
                                </div>
                                <div className={`flex-col w-full mt-6 sm:mt-6 text-gray-600 gap-6`}>
                                    <div className="flex flex-col gap-4">
                                        <div className={`${formData?.type === 'Shkolla Verore' || isFitnessForm ? 'hidden' : 'flex'} flex-col gap-4`}>
                                            <h3 className="text-lg font-bold text-gray-800 uppercase tracking-wide">{t('swimming_skills')}</h3>
                                            <div className="flex flex-col gap-3 bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                <label onClick={() => setFormData({ ...formData, swimmingExpertise: 'poor' })} className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg hover:bg-white transition-colors border-2 border-transparent hover:border-blue-200 peer-checked:border-blue-500 peer-checked:bg-blue-50">
                                                    <input
                                                        type="radio"
                                                        name="radio1"
                                                        className="hidden peer"
                                                        checked={formData?.swimmingExpertise === 'poor'}
                                                        onChange={() => setFormData({ ...formData, swimmingExpertise: 'poor' })}
                                                    />
                                                    <div className="w-5 h-5 border-2 border-gray-400 rounded-full peer-checked:border-blue-500 peer-checked:bg-blue-500 flex items-center justify-center">
                                                        <div className="w-2 h-2 bg-white rounded-full hidden peer-checked:block"></div>
                                                    </div>
                                                    <span className="font-medium text-gray-700">{t('cantSwim')}</span>
                                                </label>
                                                <label onClick={() => setFormData({ ...formData, swimmingExpertise: 'average' })} className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg hover:bg-white transition-colors border-2 border-transparent hover:border-blue-200 peer-checked:border-blue-500 peer-checked:bg-blue-50">
                                                    <input
                                                        type="radio"
                                                        name="radio1"
                                                        className="hidden peer"
                                                        checked={formData?.swimmingExpertise === 'average'}
                                                        onChange={() => setFormData({ ...formData, swimmingExpertise: 'average' })}
                                                    />
                                                    <div className="w-5 h-5 border-2 border-gray-400 rounded-full peer-checked:border-blue-500 peer-checked:bg-blue-500 flex items-center justify-center">
                                                        <div className="w-2 h-2 bg-white rounded-full hidden peer-checked:block"></div>
                                                    </div>
                                                    <span className="font-medium text-gray-700">{t('canSwim')}</span>
                                                </label>
                                                <label onClick={() => setFormData({ ...formData, swimmingExpertise: 'good' })} className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg hover:bg-white transition-colors border-2 border-transparent hover:border-blue-200 peer-checked:border-blue-500 peer-checked:bg-blue-50">
                                                    <input
                                                        type="radio"
                                                        name="radio1"
                                                        className="hidden peer"
                                                        checked={formData?.swimmingExpertise === 'good'}
                                                        onChange={() => setFormData({ ...formData, swimmingExpertise: 'good' })}
                                                    />
                                                    <div className="w-5 h-5 border-2 border-gray-400 rounded-full peer-checked:border-blue-500 peer-checked:bg-blue-500 flex items-center justify-center">
                                                        <div className="w-2 h-2 bg-white rounded-full hidden peer-checked:block"></div>
                                                    </div>
                                                    <span className="font-medium text-gray-700">{t('swimWell')}</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className={`flex-col gap-4`}>
                                            <div className="pt-4 border-t-2 border-gray-200 mt-4 w-full">
                                                <label className="text-lg font-bold text-gray-800 uppercase tracking-wide mb-4 block">{t('health_problems')}</label>
                                                <div className="flex flex-row gap-4">
                                                    <label onClick={() => setFormData({ ...formData, healthProblems: true })} className="flex items-center space-x-3 cursor-pointer px-4 py-3 rounded-lg border-2 border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all peer-checked:border-blue-500 peer-checked:bg-blue-50">
                                                        <input
                                                            type="radio"
                                                            name="radio2"
                                                            className="hidden peer"
                                                            checked={formData?.healthProblems === true}
                                                            onChange={() => setFormData({ ...formData, healthProblems: true })}
                                                        />
                                                        <div className="w-5 h-5 border-2 border-gray-400 rounded-full peer-checked:border-blue-500 peer-checked:bg-blue-500 flex items-center justify-center">
                                                            <div className="w-2 h-2 bg-white rounded-full hidden peer-checked:block"></div>
                                                        </div>
                                                        <span className="font-medium text-gray-700">{t('yes')}</span>
                                                    </label>
                                                    <label onClick={() => setFormData({ ...formData, healthProblems: false })} className="flex items-center space-x-3 cursor-pointer px-4 py-3 rounded-lg border-2 border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all peer-checked:border-blue-500 peer-checked:bg-blue-50">
                                                        <input
                                                            type="radio"
                                                            name="radio2"
                                                            className="hidden peer"
                                                            checked={formData?.healthProblems === false}
                                                            onChange={() => setFormData({ ...formData, healthProblems: false })}
                                                        />
                                                        <div className="w-5 h-5 border-2 border-gray-400 rounded-full peer-checked:border-blue-500 peer-checked:bg-blue-500 flex items-center justify-center">
                                                            <div className="w-2 h-2 bg-white rounded-full hidden peer-checked:block"></div>
                                                        </div>
                                                        <span className="font-medium text-gray-700">{t('no')}</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <p className="text-sm text-gray-500 italic">{t('describe_health_problems')}</p>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-3">
                                        <input onChange={(e) => setFormData({ ...formData, healthProblemDescription: e.target.value })} value={formData.healthProblemDescription} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Përshkruani problemet shëndetësore (nëse ka)" />
                                    </div>

                                    <div className={`${isFitnessForm ? 'hidden' : 'flex'} flex-col gap-2 flex-wrap`}>
                                        <div className='flex flex-row gap-5 mt-5'>
                                            {registrations && registrations.map((registration, index) => (
                                                <div className='flex cursor-pointer flex-row rounded-2xl p-1 px-2 gap-5 items-center border-2 border-[#0062FF]' >
                                                    <span onClick={() => setFormData(registration)} className='text-[#0062FF]'>{registration.firstName} {registration.lastName}</span>
                                                    <img src={Cross} onClick={() => handleRemoveRegistration(index)} className='w-4 h-4 ' />
                                                </div>
                                            ))}
                                        </div>

                                        <div>
                                            <button
                                                onClick={(e) => {
                                                    if (isDuplicateRegistration()) {
                                                        toast.error(t('duplicate_member'));
                                                    } else {
                                                        toast.success(t('member_added'));
                                                        handleSubmit(e);
                                                    }
                                                }} className={`flex flex-row items-center justify-center mt-5 rounded-lg border-2 ${showBlackFriday ? 'border-black-600 text-black-600 hover:bg-black-600 hover:text-white hover:shadow-lg' : 'border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white'} py-3 px-6 gap-2 font-bold text-sm uppercase tracking-wide shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-[1.02] ${isDuplicateRegistration() ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                                {t('add_member')}
                                                <img src={Plus} className='w-5 h-5' />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Packages section - Show first on mobile, second on desktop */}
                <div className={`flex-col gap-10 ${form === 'Individual' ? 'flex' : 'hidden'} order-1 sm:order-2`}>
                    {isStepArena ? (
                        <StepArenaIndividualSection formData={formData} setFormData={setFormData} />
                    ) : (
                    <>
                    <div className="flex flex-col gap-5 relative">
                        <IndividualDiscountCard formData={formData} setFormData={setFormData} discountData={discountData.Individual.basic} />
                    </div>
                    <div className="flex flex-col gap-5 relative">
                        <IndividualDiscountCard formData={formData} setFormData={setFormData} discountData={discountData.Individual.premium} />
                    </div>
                    </>
                    )}
                </div>
                <div className={`flex-col gap-10 ${form === 'Kids Fitness' ? 'flex' : 'hidden'} order-1 sm:order-2`}>
                    <div className="flex flex-col gap-5">
                        <h2 className="text-2xl font-bold">{t('kids_fitness')}</h2>
                        <FitnessKidDiscountCard formData={formData} setFormData={setFormData} discountData={discountData.Individual.basic} />
                    </div>
                </div>
                <div className={`flex-col gap-10 ${form === 'Adults' ? 'flex' : 'hidden'} order-1 sm:order-2`}>
                    <div className="flex flex-col gap-5">
                        <h2 className="text-2xl font-bold">Step Adults</h2>
                        <AdultsFitnessDiscountCard setFormData={setFormData} />
                    </div>
                </div>
                <div className={`flex-col gap-3 ${form === 'Shkolla e Notit' ? 'flex' : 'hidden'} order-1 sm:order-2`}>
                    <div className="flex flex-col gap-1">
                        {/* <div className="flex items-center gap-3">
                            <h2 className="text-2xl font-bold">{t('swimming_school_infants')}</h2>
                            {showBlackFriday && (
                                <span className="bg-black-600 text-white px-2 py-1 rounded text-xs font-bold">ZBRITJE</span>
                            )}
                        </div> */}
                        <TeamDiscountCard formData={formData} setFormData={setFormData} discountData={discountData.Team.Infants} ageGroup="infants" ageStart={3} ageEnd={4} />
                    </div>
                    <div className="flex flex-col gap-1">
                        {/* <div className="flex items-center gap-3">
                            <h2 className="text-2xl font-bold">{t('swimming_school_children')}</h2>
                            {showBlackFriday && (
                                <span className="bg-black-600 text-white px-2 py-1 rounded text-xs font-bold">ZBRITJE</span>
                            )}
                        </div> */}
                        <TeamDiscountCard formData={formData} setFormData={setFormData} discountData={discountData.Team.Children} ageGroup="children" ageStart={5} ageEnd={17} />
                    </div>
                    <div className="flex flex-col gap-1">
                        {/* <div className="flex items-center gap-3">
                            <h2 className="text-2xl font-bold">{t('swimming_school_adults')}</h2>
                            {showBlackFriday && (
                                <span className="bg-black-600 text-white px-2 py-1 rounded text-xs font-bold">ZBRITJE</span>
                            )}
                        </div> */}
                        <TeamDiscountCard formData={formData} setFormData={setFormData} discountData={discountData.Team.Adults} ageGroup="adult" ageStart={18} ageEnd={100} />
                    </div>
                </div>
                <div className={`flex-col gap-3 ${form === 'Rezervime Grupore' ? 'flex' : 'hidden'} items-center justify-center order-1 sm:order-2`}>
                    <div className="p-6 text-center text-white border rounded-lg shadow-lg bg-gradient-to-r from-blue-400 to-blue-600 w-80">
                        <h2 className="mb-2 text-2xl font-bold">{t('total_amount')}</h2>
                        <p className="text-3xl font-semibold">{`${calculateTotalAmount()}€`}</p>
                    </div>
                </div>
                <div className={`flex-col gap-3 ${form === 'Summer School' ? 'flex' : 'hidden'} order-1 sm:order-2`}>
                    <SummerSchoolSection formData={formData} setFormData={setFormData} />
                </div>
                <div className={`flex-col gap-3 ${form === 'Daily Pass' ? 'flex' : 'hidden'} order-1 sm:order-2`}>
                    <DailyPassSection formData={formData} setFormData={setFormData} />
                </div>
            </div>
            <div className="flex flex-col justify-between gap-0 sm:gap-5 lg:gap-10 sm:flex-row">
                <div className="flex flex-col items-end justify-end w-full gap-2 mt-5 sm:mt-20">
                <button
                        onClick={(e) => {
                            if (!checkbox && form !== "Rezervime Grupore") {
                                toast.warning('Nuk jeni pajtuar me kushtet e kontratës!');
                                return;
                            }

                            if (form === "Rezervime Grupore") {
                                handleGroupReservationSubmit(e);
                            } else {
                                if (registrations.length === 0) {
                                    if (formData.healthProblems === true && formData.healthProblemDescription === "") {
                                        toast.warning('Ju lutemi përshkruani problemet shëndetësore');
                                    } else if (formData.time === 0) {
                                        toast.warning('Ju lutemi zgjidhni një plan');
                                    } else if (formData.type === 'Individual' && (!formData.firstName || !formData.lastName || !formData.dateOfBirth || !formData.address || !formData.email || !formData.phone || formData.healthProblems == null || !formData.swimmingExpertise)) {
                                        toast.warning('Ju lutemi plotësoni të gjitha fushat');
                                    } else if ((formData.type === 'kids fitness' || formData.type === 'Kids Fitness' || formData.type === 'Adults') && (!formData.firstName || !formData.lastName || !formData.dateOfBirth || !formData.address || !formData.email || !formData.phone || formData.healthProblems == null)) {
                                        toast.warning('Ju lutemi plotësoni të gjitha fushat');
                                    } else if (formData.type === 'Shkolla e Notit' && (!formData.firstName || !formData.lastName || !formData.dateOfBirth || !formData.address || !formData.email || !formData.phone || formData.healthProblems == null || !formData.swimmingExpertise)) {
                                        toast.warning('Ju lutemi plotësoni të gjitha fushat');
                                    } else if (formData.type === 'Shkolla e Notit' && formData.age < 3) {
                                        toast.warning('Mosha e fëmijës duhet të jetë mbi 3 vjeç');
                                    } else if (formData.type === 'Summer School' && (
                                        !formData.firstName || !formData.phone || !formData.summerSchoolPool ||
                                        !formData.summerProgram || !formData.summerPlanType || !formData.summerPlan ||
                                        (formData.summerPlan === 'Seasonal' && !formData.summerSeasonalStartMonth) ||
                                        !Array.isArray(formData.days) || formData.days.length === 0 ||
                                        formData.days.some(s => !s?.day || !s?.time)
                                    )) {
                                        toast.warning('Ju lutemi plotësoni të gjitha fushat e Summer School');
                                    } else if (formData.type === 'Daily Pass' && (
                                        !formData.firstName || !formData.phone || !formData.entryDate
                                    )) {
                                        toast.warning('Ju lutemi plotësoni emrin, telefonin dhe datën e hyrjes');
                                    } else {
                                        handleRegister();
                                        setStep(2);
                                    }
                                } else {
                                    handleRegister();
                                    setStep(2);
                                }
                            }
                        }}
                        className={`px-10 py-2 font-medium transition-all duration-200 rounded-lg max-w-fit ${checkbox === false ? 'opacity-50' : 'opacity-100'} ${showBlackFriday && checkbox ? 'text-black bg-gradient-to-r from-black-600 via-black-700 to-black hover:from-black-700 hover:via-black-800 hover:to-black shadow-lg hover:shadow-xl transform hover:scale-105 duration-300' : 'text-gray-500 hover:bg-[#000000] hover:text-white duration-300 transition-all'}`}
                    >
                        {form === "Rezervime Grupore" ? 'Dërgo Kërkesën' : 'Regjistrohu'}
                    </button>
                    <div className="flex flex-row gap-2">
                        <label>{t('agree_terms')} <span className="text-blue-600">{t('terms_conditions')}</span></label>
                        <input onClick={() => { setCheckbox(!checkbox) }} type="checkbox" name="" className="w-5 bg-gray-300" />
                    </div>
                </div>
            </div>
        </div>
    );
}
